import { useQuery } from "@tanstack/react-query";
import { getCategory } from "../api";

export const useGetCategory = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["CATEGORY"],
    queryFn: getCategory,
    select: ({ data }) => data,
  });

  return { category: data, isLoading };
};
